<template>
    <div class="product-card" :style="product.border_color">
        <button  class="btn btn-wishlist btn-brand "  >
                    <img :src="product.brandlogo" alt="">
        </button>
        
        <div class="product-card-top">
            <a :href="productUrl" class="product-image" v-if="product.brandlogo" >
                <img  v-if="product.islastchance" src="https://ucanbe.tn/lastchance.png" class="lastchance_special_tag"   alt="UCANbe Tunisie lastchance">


                <img :src="baseImage" :class="{ 'image-placeholder': !hasBaseImage }" alt="UCANbe Tunisie">
            </a>

          


            <div class="product-card-actions">
                <button class="btn btn-wishlist" :class="{ 'added': inWishlist }"
                    :title="$trans('storefront::product_card.wishlist')" @click="syncWishlist">
                    <i class="la-heart" :class="inWishlist ? 'las' : 'lar'"></i>
                </button>

        

                <!--
                    <button
                    class="btn btn-compare"
                    :class="{ 'added': inCompareList }"
                    :title="$trans('storefront::product_card.compare')"
                    @click="syncCompareList"
                >
                    <i class="las la-random"></i>
                </button> -->
            </div>

            <ul class="list-inline product-badge">


                <li class="badge badge-danger" v-html="product.flash_title"  v-if="product.flash_time !== false && product.etat_image_compagne==false"     :style="{ backgroundColor: product.btn_bg_color, color: product.btn_text_color }"></li>
                <li class="badge" v-if="product.flash_time!== false && product.etat_image_compagne" ><img :src="product.image_compagne" :alt="product.flash_title" style="width: 95px;margin-right: -25px;margin-top: -15px;"></li>
                <li class="badge badge-danger" v-if="product.flash_time !== false && product.chrono != false">
                    <div class="countdown-container-product"  >
                        <i class="lar la-clock" aria-hidden="true"></i>
                        <span :id="'countdown-hours' + product.id"></span>h
                        <span :id="'countdown-minutes' + product.id"></span>m
                        <span :id="'countdown-seconds' + product.id"></span>s
                    </div>
                </li>
               <!--  <li class="badge badge-danger" v-if="product.is_out_of_stock">
                    {{ $trans('storefront::product_card.out_of_stock') }}
                </li> -->
                <li class="badge badge-primary" v-else-if="product.is_new">
                    {{ $trans('storefront::product_card.new') }}
                </li>

                <li class="badge badge-success" v-if="product.has_percentage_special_price && product.flash_time == false" >
                    -{{ product.special_price_percent }}%
                </li>

                <li class="badge badge-success" v-if="(product.brand && [338, 339, 340, 341, 354, 358, 359, 360, 368, 409, 416, 417, 347, 348, 349, 350, 351, 352, 353, 384, 401, 402, 404, 405, 411, 487, 357, 410, 355, 356, 403, 406, 408, 486, 361, 362, 363, 364, 365, 366, 367, 374, 414, 369, 370, 371, 426, 446, 418, 460, 465, 419].includes(product.brand.category_id)) || (product.categories && product.categories.some(category => [338, 339, 340, 341, 354, 358, 359, 360, 368, 409, 416, 417, 347, 348, 349, 350, 351, 352, 353, 384, 401, 402, 404, 405, 411, 487, 357, 410, 355, 356, 403, 406, 408, 486, 361, 362, 363, 364, 365, 366, 367, 374, 414, 369, 370, 371, 426, 446, 418, 460, 465, 419].includes(category.id)))">
                    Selon disponibilité                 
                </li>

                <li class="badge badge-danger" style="padding:6px 6px;" v-if=" (product.flash_time == false) && ((product.brand && [502].includes(product.brand.category_id)) || (product.categories && product.categories.some(category => [502].includes(category.id))))">
                    Offre Destockage
                </li>

            </ul>

            <div style="margin-top:10px;display: flex;align-items: center;justify-content: center;" v-if="product.monoszone_card" class="brief-description" v-html="product.monoszone_card"></div>
        </div>

        <div class="product-card-middle">
            
            
            <ProductRating :ratingPercent="product.rating_percent" :reviewCount="product.reviews.length" />

            <a :href="productUrl" class="product-name">
                <h6>{{ product.name }}</h6>
            </a>

            

            <div class="product-price product-price-clone" v-html="product.formatted_price"></div>
        </div>

        <div class="product-card-bottom">
            <div class="product-price" v-html="product.formatted_price"></div>

            <button v-if="hasNoOption || product.is_out_of_stock" class="btn btn-primary btn-add-to-cart"
                :class="{ 'btn-loading': addingToCart }" :disabled="product.is_out_of_stock" @click="addToCart">
                <i class="las la-cart-arrow-down"></i>
                {{ $trans('storefront::product_card.add_to_cart') }}
            </button>

            <a v-else :href="productUrl" class="btn btn-primary btn-add-to-cart">
                <i class="las la-eye"></i>
                {{ $trans('storefront::product_card.view_options') }}
            </a>
        </div>
    </div>
</template>

<script>
import ProductRating from './ProductRating.vue';
import ProductCardMixin from '../mixins/ProductCardMixin';

export default {
    components: { ProductRating },

    mixins: [
        ProductCardMixin,
    ],

    props: ['product'],
    mounted() {
        if (this.product.flash_time && this.product.chrono){

            const countdownDate = new Date(this.product.flash_time);

            const countdownHoursElement = document.getElementById('countdown-hours' + this.product.id);
            const countdownMinutesElement = document.getElementById('countdown-minutes' + this.product.id);
            const countdownSecondsElement = document.getElementById('countdown-seconds' + this.product.id);

            function updateCountdown() {
                const now = new Date().getTime();
                const remainingTime = countdownDate - now;

                const hours = Math.floor(remainingTime / (1000 * 60 * 60));
                const minutes = Math.floor((remainingTime % (1000 * 60 * 60)) / (1000 * 60));
                const seconds = Math.floor((remainingTime % (1000 * 60)) / 1000);

                if(countdownHoursElement && countdownMinutesElement && countdownSecondsElement){
                    countdownHoursElement.textContent = hours;
                    countdownMinutesElement.textContent = minutes;
                    countdownSecondsElement.textContent = seconds;
                }
                

                if (remainingTime <= 0) {
                    clearInterval(countdownInterval);
                }
            }

            updateCountdown();

            const countdownInterval = setInterval(updateCountdown, 1000);
        }
    }
};
</script>
;
</script>
